import { useState, useRef, useEffect } from 'react';
import { Send, Paperclip } from 'lucide-react';

export const ChatInput = ({ onSend, disabled = false, placeholder }) => {
  const [message, setMessage] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSend(message.trim());
      setMessage('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  // Focus input on mount
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <form 
      onSubmit={handleSubmit} 
      className="p-4"
      data-testid="chat-input-form"
    >
      <div className="relative flex items-center gap-3">
        <div className="flex-1 relative">
          <textarea
            ref={inputRef}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder || "Scrivi un messaggio..."}
            disabled={disabled}
            rows={1}
            className="chat-input w-full resize-none pr-12 min-h-[52px] max-h-32"
            style={{ height: 'auto' }}
            data-testid="chat-input"
          />
          
          <button
            type="submit"
            disabled={disabled || !message.trim()}
            className={`absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 ${
              message.trim() && !disabled
                ? 'bg-umbria-olive text-white hover:bg-umbria-olive-dark'
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
            data-testid="chat-send-btn"
          >
            <Send size={18} />
          </button>
        </div>
      </div>
      
      <p className="text-xs text-gray-400 text-center mt-2">
        Premi Invio per inviare
      </p>
    </form>
  );
};

export default ChatInput;
